import React from "react";

import CloseIcon from "@uui/XClose";

import Typography from "@mui/material/Typography";

import { TYPE_TO_ICON_CONFIG } from "@app/analytics/Home/constants";
import type { FeedItem } from "@app/analytics/Home/types";

import IconBackground from "@rui/IconBackground";
import IconButton from "@rui/IconButton";
import { Link } from "@rui/Link";
import Stack, { Row } from "@rui/Stack";

const HeaderIcon = ({ type }: { type: FeedItem["type"] }) => {
  const { Icon, backgroundColor, color } = TYPE_TO_ICON_CONFIG[type];

  return (
    <IconBackground
      height={32}
      sx={{ backgroundColor, color }}
      borderRadius="6px"
    >
      <Icon />
    </IconBackground>
  );
};

const HomeFeedItemHeader = ({
  align,
  link,
  onClose,
  timestamp,
  title,
  type,
}: {
  align: "left" | "right";
  link?: {
    label: string;
    href: string;
  };
  onClose?: () => void;
  timestamp: FeedItem["timestamp"];
  title: FeedItem["title"];
  type: FeedItem["type"];
}) => {
  const flexDirection = align === "left" ? "row" : "row-reverse";
  return (
    <Row justifyContent="space-between" flexDirection={flexDirection}>
      <Row
        justifyContent={align === "left" ? "flex-start" : "space-between"}
        flexDirection={flexDirection}
        spacing={1}
      >
        <HeaderIcon type={type} />
        <Stack>
          <Typography variant="bodySecondaryMed" color="shades.neutral.800">
            {title}
          </Typography>
          <Typography variant="labelReg" color="shades.neutral.500">
            {link && (
              <>
                <Link fontWeight={400} href={link.href}>
                  {link.label}
                </Link>
                {" • "}
              </>
            )}
            <span title={timestamp.toFormat("DDD h:mm a")}>
              {timestamp.toRelative()}
            </span>
          </Typography>
        </Stack>
      </Row>
      {onClose && (
        <IconButton sx={{ height: "24px", width: "24px" }} onClick={onClose}>
          <CloseIcon sx={{ fontSize: "16px" }} />
        </IconButton>
      )}
    </Row>
  );
};

export default HomeFeedItemHeader;
